/* global fetch, io */
import EventEmitter from '../Utils/EventEmitter';
import Utils from '../Utils/Utils';
import MediaPlayer from './MediaPlayer';
import Live from './Live';
import Vod from './Vod';
import Manager  from './Manager';


export default class Synople extends EventEmitter {

    apiUrl = '';
    mediaPlayer;
    chapters = [];
    chaptersByStart = [];
    currentChapterIndex = -1;
    currentChapterOdjIndex = -1;
    
    constructor() {
        super();
        
        if(!window.isVod)
            this.live = new Live(this);
        else
            this.vod = new Vod(this);
        
        if(window.manager)
            this.manager = new Manager(this);
    }

    player(p = false) {
        if (!p)
            return this.mediaPlayer;
        else {
            console.log('iu')
            this.mediaPlayer = new MediaPlayer(p, this);
        }
    }

    async getChapters(programId) {
        let params = '';
        if (window.query && window.query.s) {
            params += '?s=' + window.query.s + '&e=' + window.query.e
        }
        if(window.local)
            this.chapters = window.chapters;
        else
            this.chapters = await this.fetch('/chapters/' + programId + params)
        
        if(this.chapters[this.chapters.length - 1].duration == 0) {
            this.setDurationOfLastElement();
        }
    
        return this.chapters;
    }
    
    async setDurationOfLastElement() {
        while(this.mediaPlayer.getTotalDuration() == 0) {
            await Utils.sleep(1000);
        }
        this.chapters[this.chapters.length - 1].duration = this.mediaPlayer.getTotalDuration() - this.chapters[this.chapters.length - 1].start_second;
    }

    async getSpeakerPrograms(programId) {
        this.speakers = await this.fetch('/speakers/' + programId)
        return this.speakers;
    }


    search(s) {
        let words = s.split(' ');
        for (var i in words) {
            words[i] = words[i].normalize('NFD').replace(/[\u0300-\u036f]/g, "").trim().toLowerCase();
        }

        if (!this.chaptersWords) {
            this.chaptersWords = [];
            for (var i in this.chapters) {
                let title = this.chapters[i].title.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase();
                this.chaptersWords.push(title);
            }
        }

        let finded = []
        for (var i in this.chaptersWords) {
            let find = true;
            for (var j in words) {
                if (this.chaptersWords[i].indexOf(words[j]) < 0)
                    find = false
            }
            if (find)
                finded.push(this.chapters[i])
        }

        return finded;

    }

    getChaptersBySpeaker(speaker) { 
        let finded = [];
        for (var i in this.chapters) {
            if (this.chapters[i].speaker && this.chapters[i].title == speaker) {
                let ind = finded.push(this.chapters[i]);
            }
        }
        return finded;
    }
    
    getLiveChaptersBySpeaker(speakerId) {
		if(speakerId == -1)
			return;
        let finded = [];
        for (var i in window.sdk.live.chapters) {
            let chapter = window.sdk.live.chapters[i];
            if (chapter.speakers) {
                for(var j in chapter.speakers) {
                    if(chapter.speakers[j].value.speaker.id == speakerId) {
                        finded.push({ ... chapter.speakers[j], chapterId: chapter.id, title: chapter.title + chapter.description });
                    }
                }
            }
        }
        return finded;
    }
    

    async findCurrentChapter(currentTime) {
        function isStarted(item) {
            return item.start_second > currentTime;
        }
        
        //console.log(this.chapters);

        let index = this.chapters.findIndex(isStarted) - 1;
        
        if(index < 0 && this.chapters[this.chapters.length - 1].start_second < currentTime)
            index = this.chapters.length - 1;
        
        if (index < 0) {
            index = -1;
            return;
        }
        let elems = document.querySelectorAll('.chapter-current');
        if(elems){
            let id = this.chapters[index].id;
            [].forEach.call(elems, function(el) { 
                if(el.id !='chapter-' + id) el.classList.remove('chapter-current')
            });
        }
        // document.getElementById('chapter-' + this.chapters[index].id).style.backgroundColor = window.theme.palette.primary.main;
        document.getElementById('chapter-' + this.chapters[index].id).classList.add('chapter-current');
        try {			
            document.getElementById('chapter-' + this.chapters[index].id).querySelector('.chapter-title-speaker').style.color = window.theme.palette.primary.main;
        } catch (e) {

        }
		
	
        let end = false;
		
		if(window.isVod && this.chapters[index].keywords != 'speaker') {
			this.hideSpeaker()
			this.hideSpeakerExt();
		}
		
        if(this.chapters[index].chapter_type == 1){			
            index = this.chapters.findIndex((el,key) => key > index && el.chapter_type == 0);
            if(index == -1){
                end = true;
                index = this.chapters.length - 1 ;
                window.sdk.player().stop();
                await window.sdk.player().seek(this.chapters[index].start_second + this.chapters[index].duration);
            }
            else{
                await window.sdk.player().seek(this.chapters[index].start_second);
            }
        }        
        if(!end){
            if (this.currentChapterIndex != index) {
                let oldIndex = this.currentChapterIndex;
                
                this.currentChapterIndex = index;
                if(this.chapters[oldIndex]) {
				
                    // document.getElementById('chapter-' + this.chapters[oldIndex].id).style.backgroundColor = Utils.hexToRGB(window.theme.palette.primary.main, 0.11);
                    document.getElementById('chapter-' + this.chapters[oldIndex].id).style.backgroundColor = '';
                    try {
                        document.getElementById('chapter-' + this.chapters[oldIndex].id).querySelector('.chapter-title-speaker').style.color = '';
                    } catch (e) {
                        
                    }
                }
                
                this.emit('currentChapterIndex', {
                    index: index,
                    oldIndex: oldIndex
                });
                if (this.chapters[index] && this.chapters[index].speaker) {
                    if (this.currentChapterOdjIndex != this.chapters[index].odjIndex) {
                        let oldIndex = this.currentChapterOdjIndex;
                        this.currentChapterOdjIndex = this.chapters[index].odjIndex
                        this.emit('currentChapterOdjIndex', {
                            index: this.currentChapterOdjIndex,
                            oldIndex: oldIndex,
                            id: this.chapters[index].id
                        });
                    }
                }
                else {					
                    this.emit('currentChapterOdjIndex', {
                        oldIndex: this.currentChapterOdjIndex,
                        index: false
                    });
                    this.currentChapterOdjIndex = -1
                }
            }
        }
    }

    getCurrentChapter() {
        if(window.live) {
            return this.live.getCurrentCue('chapter');
        }
        else
            return this.chapters[this.currentChapterIndex];
    }

    getChapter(index) {
        return this.chapters[index];
    }
    
    async convertToVod() {
        let res = await this.fetch('/manager/stream/' +  + window.programId + '/live/to/vod', {
            method: 'POST'
        });
        if(res.error) {
            alert('Nous devons vérifier la vidéo')
        }
        else {
            document.location.href = document.location.href;
        }
    }
    
    async convertToLive() {
        await this.fetch('/manager/stream/' +  + window.programId + '/vod/to/live', {
            method: 'POST'
        });
        document.location.href = document.location.href;
    }
    
    async getSpeaker(id, name) {
        return await this.fetch('/speaker/' + id, {
            method: 'POST',
            body: JSON.stringify({
                name: name
            }),
            headers: {
                "Content-Type": "application/json"
            }
        });
    }

    async fetch(uri, params = {}) {
        this.emit('load');
        let response = await fetch(this.apiUrl + uri, params).catch((err) => {

        });
        this.emit('loadComplete');
        return response.json();
    }

    async sendExtractByMail(start, end, email, isAudioOnly) {
        let uri = '/extract';
        if(window.live)
            uri = '/stream/' + window.programId + '/extract';
            
        await this.fetch(uri, {
            method: 'POST',
            body: JSON.stringify({
                programId: window.programId,
                start: start,
                end: end,
                email: email,
                isAudioOnly: isAudioOnly
            }),
            headers: {
                "Content-Type": "application/json"
            }
        })
    }

    getDateFromSecond(second) {
        let date = new Date(null);
        date.setSeconds(second);
        return date.toISOString().substr(11, 8);
    }

    

    showTab() {
        let res = true;

        if (window.custom) {
            if (window.custom.synople.playerOnly === true)
                res = false;
        }

        if (window.query && window.query.odj == 'hide')
            res = false;

        return res;

    }
    
    isOdjOnly() {
        if (window.query && window.query.odj == 'only')
            return true
        return false;
    }
    
    isOverlay() {
        if (window.query && window.query.odj == 'overlay')
            return true
        return false;
    }
    
    isExtended() {
        if (window.query && window.query.odj == 'extend')
            return true
        return false;
    }
    
    isByPassUrl() {
        if (window.query && window.query.stream)
            return  window.query.stream
        return false;
    }
    
    hideSpeaker() {
        try {
        document.getElementById('speaker_bandeau').style.opacity = 0;
        document.getElementById('speaker_bandeau').style.zIndex = -1;
        }
        catch(err) {
            
        }
    }
	
	bbcodeToHtml(text) {
		// Remplacer les \r\n par <br/>
		text = text.replace(/\r\n/g, "<br/>");
	
		// Remplacer les [b] par <b>
		text = text.replace(/\[b\]/g, "<b>");
	
		// Remplacer les [/b] par </b>
		text = text.replace(/\[\/b\]/g, "</b>");
	
		// Remplacer les [i] par <i>
		text = text.replace(/\[i\]/g, "<i>");
	
		// Remplacer les [/i] par </i>
		text = text.replace(/\[\/i\]/g, "</i>");
		
		// Remplacer les [i] par <i>
		text = text.replace(/\[u\]/g, "<u>");
	
		// Remplacer les [/i] par </i>
		text = text.replace(/\[\/u\]/g, "</u>");
	
		return text;
	}
	
	hideSpeakerExt() {
		if(window.sdk.isExtended()) {
			document.querySelector('.fixed-speaker__name').innerHTML = '';
			document.querySelector('.fixed-speaker__job').innerHTML = '';
			document.querySelector('.fixed-speaker__img img').src = '/public/trans.png';
			document.querySelector('.fixed-speaker__group').innerHTML = '';
            document.querySelector('.fixed-speaker').classList.add('empty');
		}
		
	}

    async showSpeaker(data, data2) {
		console.log('showSpeaker', data);
		
        if(data.id != this.currentSpeakerId) {
            this.hideSpeaker();
        }
		
		if(typeof data != 'object')
			return;
		
		while(!document.getElementById('speaker_name')) {
			await Utils.sleep(1000);
		}
        
		
		
		
		
        this.currentSpeakerId = data.id;
        
        if(this.timeout1)
            clearTimeout(this.timeout1);
        if(this.timeout2)
            clearTimeout(this.timeout2);
        if(this.timeout0)
            clearTimeout(this.timeout0);
        
        let delay = 7;
        let delay_show = 7;
        if(window.custom) {
            delay = parseInt(window.custom.synople.speaker_delay) + 0.1;
            delay_show = parseInt(window.custom.synople.speaker_show_delay) + 0.1;
			if(delay_show < 5)
				delay_show = 5;
        }
		
		
		this.hideSpeakerExt();
		
		this.hideSpeaker();
				
		
		console.log('delay', delay, delay_show);
        
        this.timeout0 = setTimeout(async () => {
            this.timeout1 = setTimeout(() => {
                if(!window.local){
                    if(document.querySelector('.jw-text-track-display')) {
                        let css = '.jw-text-track-display.jw-reset {top: ' + parseInt(parseInt(document.getElementById('speaker_bandeau').style.top,10) - parseInt(document.querySelector('.jw-text-track-display').offsetHeight,10) - 20) + 'px !important }';
                        if(document.getElementById('customstyle'))
                            document.getElementById('customstyle').innerHTML = '<style>' + css + '</style>';                 
                    }
                }
            }, 200)  
            
            try {
                document.getElementById('speaker_name').innerHTML = decodeURIComponent(escape(data.title));
                document.getElementById('speaker_function').innerHTML = decodeURIComponent(escape(data.description));
            }
            catch(err) {
                document.getElementById('speaker_name').innerHTML = data.title;
                document.getElementById('speaker_function').innerHTML = data.description;
            }
			
			let idImage;
            if(data2)
                idImage = data2.value.speakerId;
            else
                idImage = data.chapter_action;
			
			let dataSpeaker = {
				data: {
					intro_text: ''
				},				
			};
			
			if(!window.portraitMode && window.sdk.isExtended()) {
				if(data2)
					dataSpeaker = await this.getSpeaker(data2.value.speakerId, data.title);
				else
					dataSpeaker = await this.getSpeaker(data.chapter_action, data.title);
				console.log('dataSpeaker', dataSpeaker);
			}
			
			if(window.sdk.isExtended()) {
				try {
					document.querySelector('.fixed-speaker__name').innerHTML = decodeURIComponent(escape(data.title));
					document.querySelector('.fixed-speaker__job').innerHTML = decodeURIComponent(escape(data.description));
					document.querySelector('.fixed-speaker__img img').src = 'https://secure.synople.tv/mediacenter3/speakers/' + idImage + '.png';
					document.querySelector('.fixed-speaker__group').innerHTML = this.bbcodeToHtml(dataSpeaker.data.intro_text);
                    document.querySelector('.fixed-speaker').classList.remove('empty');
				}
				catch(err) {
					document.querySelector('.fixed-speaker__name').innerHTML = data.title;
					document.querySelector('.fixed-speaker__job').innerHTML = data.description;
					document.querySelector('.fixed-speaker__img img').src = 'https://secure.synople.tv/mediacenter3/speakers/' + idImage + '.png';
					document.querySelector('.fixed-speaker__group').innerHTML = this.bbcodeToHtml(dataSpeaker.data.intro_text);
                    document.querySelector('.fixed-speaker').classList.remove('empty');
				}
            }
			
            let el = document.querySelector('#speaker_photo');
            if(el)
                el.parentNode.removeChild(el);
            
            
            			
			
             document.getElementById('speaker_bandeau').innerHTML += '<div id="speaker_photo" class="speaker_photo" style="background-image:url(https://secure.synople.tv/mediacenter3/speakers/' + idImage + '.png)"></div>';
             // document.getElementById('speaker_bandeau').style.display = 'block';
			if(window.portraitMode || !window.sdk.isExtended()) {
				document.getElementById('speaker_bandeau').style.zIndex = 10;
				document.getElementById('speaker_bandeau').style.opacity = 1;
			}
            
            await Utils.sleep(delay_show * 1000);
            
            this.hideSpeaker();
            
            this.timeout2 = setTimeout(() => {
                if(document.getElementById('customstyle'))
                    document.getElementById('customstyle').innerHTML = '';
               // document.getElementById('speaker_bandeau').style.display = 'none';
            }, 300)
        }, delay * 1000)
    }
    
    showSlide(image){
        let el = document.getElementById("media_slide");
        //let img = document.querySelector('#media_slide img');
        if(el  && el.style.backgroundImage.replace('url("', '').replace('")', '') == image)
            return;
        if(image != ''){
            if (!el) {
                el = document.createElement("div");
                el.id = 'media_slide';
                if(window.local){
                    el.classList = 'media-player-html5';
                    document.querySelector('#player').appendChild(el);
                }
                else
                    document.querySelector('#player .jw-media').appendChild(el);
            }

            el.style.backgroundImage ='url("'+image+'")';
            if(!document.querySelector('.vod').classList.contains('player-with-slide'))
                document.querySelector('.vod').classList.add('player-with-slide')
            
        }
        else if(el && document.querySelector('.vod').classList.contains('player-with-slide')){    
            el.style.backgroundImage ='url("")';
            document.querySelector('.vod').classList.remove('player-with-slide')
        }
    }

}



// WEBPACK FOOTER //
// ./src/Sdk/Synople.js